// @flow

import React from 'react';
import styled from 'styled-components';

import { Color, Fonts, Width } from 'styles';
import { ImageLoader, Link } from 'components/Gui';
import { useImages } from 'hooks';
import { RightRoundArrow } from 'components/Svg';
import type { AllImages } from 'hooks/use-images';

const Tiles = styled.nav`
  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    margin-right: 40px;
    margin-bottom: 70px;
  }

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    margin-right: 92px;
  }

  > a {
    padding: 24px;
    border: 1px solid #d2d2d2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 24px auto 0 auto;
    max-width: 324px;
    text-decoration: none;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      width: 324px;
      flex: 0 0 auto;
    }

    @media print, screen and (min-width: ${Width.BREAK_XL}px) {
      max-width: unset;
      width: 621px;
      flex-direction: row;
      padding: 13px 25px;
    }
  }
`;

const Img = styled.div`
  width: 176px;
  margin-bottom: 16px;

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    flex: 0 0 auto;
    margin-bottom: 0;
    width: 328px;
    margin-right: 42px;
  }
`;

const TextLink = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    flex-wrap: wrap;
  }

  span {
    ${Fonts.POPPINS};
    color: ${Color.BLACK_SOUL};
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 1.15;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      font-size: 1.8rem;
    }

    @media print, screen and (min-width: ${Width.BREAK_XL}px) {
      font-size: 2.7rem;
    }
  }

  svg {
    margin-left: 7px;
    width: 1.6rem;

    @media print, screen and (min-width: ${Width.BREAK_XL}px) {
      transform: translateY(-1px);
    }
  }
`;

type Props = { tiles: { img: string, title: string, url: string }[], images: AllImages };

const LinkedImageTiles = ({ tiles, images, ...rest }: Props) => {
  const getImage = useImages(images);
  return (
    <Tiles {...rest}>
      {tiles.map(({ img, title, url }, index) => {
        const splitTitle = title.split('\n');
        return (
          <Link url={url} key={`FaqTile-${index}`} label={title}>
            <Img>
              <ImageLoader image={getImage(img)} alt="" />
            </Img>
            <TextLink>
              <div>
                <span>{splitTitle[0]}</span>
                <span>&nbsp;</span>
              </div>
              <div>
                <span>{splitTitle[1]}</span>
                {RightRoundArrow}
              </div>
            </TextLink>
          </Link>
        );
      })}
    </Tiles>
  );
};

export default LinkedImageTiles;
